import React from "react";
// import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
// import MDButton from "components/MDButton";
// import CloseIcon from "@mui/icons-material/Close";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";

const style = [
  {
    "& .MuiBox-root": {
      border: "none",
      borderRadius: "10px",
    },
  },
  {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.5)",
    p: 4,
    border: "none",
  },
];

export default function BasicModal(props) {
  const { open, onClose, children } = props;
  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={style}>
          <MDBox display="flex" justifyContent="space-between">
            <MDBox>{children}</MDBox>
          </MDBox>
        </Card>
      </Modal>
    </div>
  );
}

BasicModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
